import { render, staticRenderFns } from "./StatisticsMarksByDepartmentsIndex.vue?vue&type=template&id=3b0e091a"
import script from "./StatisticsMarksByDepartmentsIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByDepartmentsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports